import React, { FunctionComponent, useState, Fragment } from 'react'
import { injectIntl, InjectedIntlProps } from 'react-intl'
import CloseIcon from '@uniiverse/library/assets/icons/x.svg'

import { Card } from 'src/elements/Card'
import { ModalComponent as Modal } from 'src/elements/Modal/Modal'
import { isOutsideOntario } from 'src/lib/check-location'

import locale from './locale'

const style = require('./EventDisclosure.css')

interface Props {
  eventData: any,
  loading: Boolean,
  isEventSet: Boolean,
}

export const EventDisclosureComponent: FunctionComponent<Props & InjectedIntlProps> = ({
  eventData,
  loading,
  isEventSet,
  intl: { formatMessage },
}) => {
  const [open, setOpen] = useState(false)

  const getMessage = () => {
    if (isEventSet) return formatMessage(locale.eventSetCapacity)

    const totalCapacity = eventData.maxQuantity

    if (totalCapacity && (totalCapacity > 0) && (eventData.timeSlots.totalCount > 1)) {
      return formatMessage(locale.maxCapacityAcrossMultipleSlots, { totalCapacity })
    }
    else if (totalCapacity && (totalCapacity > 0)) {
      return formatMessage(locale.maxCapacityForSingleSlot, { totalCapacity })
    }
    else {
      return formatMessage(locale.noMaxCapacityForEvent, { totalCapacity })
    }
  }

  if (loading || isOutsideOntario(isEventSet, eventData)) return null

  return (
    <Fragment>
      <button className={style.link} onClick={() => setOpen(true)}>
        {formatMessage(locale.eventDisclosureInfo)}
      </button>
      <Modal showModal={open} onClose={() => setOpen(false)}>
        <Card>
          <div className={style.header}>
            {formatMessage(locale.eventDisclosureInfo)}
            <CloseIcon className={style.closeIcon} onClick={() => setOpen(false)} />
          </div>
          <div className={style.body}>
            {formatMessage(locale.eventDisclosureBody)}
            <p>{getMessage()}</p>
            <div className={style.buttonContainer}>
              <button onClick={() => setOpen(false)}>
                {formatMessage(locale.continue)}
              </button>
            </div>
          </div>
        </Card>
      </Modal>
    </Fragment>
  )
}

export const EventDisclosure = injectIntl(EventDisclosureComponent)
